// extracted by mini-css-extract-plugin
export default {"modal":"AccidentForm_modal__Jo+pi","tableCell":"AccidentForm_tableCell__FQeIa","tableTitleCell":"AccidentForm_tableTitleCell__ZStB8","steps":"AccidentForm_steps__fUPLK"};